module.exports = "<ul class=\"container has-text-centered\">\n    <li routerLink='/'>\n      <a>Home</a>\n    </li>\n    <li>\n      <a routerLink='/install'>Installation</a>\n    </li>\n    <li>\n      <a routerLink='/gallery'>Gallery</a>\n    </li>\n    <li>\n      <a routerLink='/moreproduct'>More Products</a>\n    </li>\n  </ul>"


//////////////////
// WEBPACK FOOTER
// /Users/samirjha/Project/nushing/src/app/mobile-menu/mobile-menu.component.html
// module id = ../../../../../src/app/mobile-menu/mobile-menu.component.html
// module chunks = main